import React, { createRef } from "react";
import { DeleteIcon } from "../../assets";
import "./Input.scss";

export type InputProps = {
  handleOnChange?: React.ChangeEventHandler<HTMLInputElement>;
  handleOnBlur?: React.FocusEventHandler<HTMLInputElement>;
  handleOnKeyUp?: React.KeyboardEventHandler<HTMLInputElement>;
  value?: any;
  inputValue?: any;
  disabled?: boolean;
  placeholder?: any;
  type?: string;
  maxlength?: number;
  cx?: string;
  label?: string;
  isValid?: boolean;
  removable?: boolean;
  autocomplete?: string;
  passwordVisible?: boolean;
  forwardedRef?: React.RefObject<HTMLInputElement>;
  size? : 'small' | 'normal' 
};

/**
 *
 * @param handleOnChange
 * @param handleOnBlur
 * @param handleOnKeyUp
 * @param value
 * @param inputValue
 * @param disabled
 * @param removable
 * @param placeholder
 * @param type
 * @param maxlength
 * @param cx
 * @param label
 * @param isValid
 * @param forwardedRef
 * @param autocomplete
 * @param passwordVisible
 * @param size
 * @constructor
 */
export const Input: React.FC<InputProps> = ({
  handleOnChange,
  handleOnBlur,
  handleOnKeyUp,
  value,
  inputValue,
  disabled = false,
  removable = false,
  placeholder,
  type = "text",
  maxlength,
  cx = "",
  label,
  isValid = true,
  forwardedRef,
  autocomplete = "off",
  passwordVisible = false,
  size = "normal",
}) => {
  const inputRef = createRef<HTMLInputElement>();

  const changeType = (type: string) => {
    switch (type) {
      case "password":
      case "passwordConfirm":
        return "password";
      default:
        return type;
    }
  };
  return (
    <>
      {label && <span className={"label"}>{label}</span>}
      <div className={`Input ${isValid} ${cx} size_${size} ${disabled && "disabled"}`}>
        <input
          autoCapitalize={"off"}
          className={`${disabled ? "disabled" : ""}`}
          autoComplete={autocomplete}
          type={changeType(type)}
          placeholder={placeholder}
          defaultValue={inputValue}
          onChange={(e) => {
            if (!!handleOnChange) {
              handleOnChange(e);
            }
          }}
          onBlur={(e) => {
            if (!!handleOnBlur) {
              handleOnBlur(e);
            }
          }}
          onKeyUp={(e) => {
            if (!!handleOnKeyUp) {
              handleOnKeyUp(e);
            }
          }}
          disabled={disabled}
          ref={forwardedRef || inputRef}
          maxLength={maxlength}
          value={value}
        />
        {passwordVisible && (
          <div
            className={"change-type"}
            onMouseOver={() => {
              const r = (forwardedRef ?? inputRef).current;
              if (!r) return;
              r.type = "text";
            }}
            onMouseOut={() => {
              const r = (forwardedRef ?? inputRef).current;
              if (!r) return;
              r.type = "password";
            }}
          >
            보기
          </div>
        )}
        {removable && (
          <DeleteIcon
            onClick={() => {
              const r = (forwardedRef ?? inputRef).current;
              if (!r) return;
              r.value = "";
            }}
          />
        )}
      </div>
      {!isValid && <span>invalidate!</span>}
    </>
  );
};

export default Input;
